"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaidInstitutionSentinel = void 0;
var PlaidInstitutionSentinel;
(function (PlaidInstitutionSentinel) {
    PlaidInstitutionSentinel["unknownPlaidInstitutionName"] = "UNKNOWN_PLAID_INSTITUTION_NAME";
})(PlaidInstitutionSentinel || (exports.PlaidInstitutionSentinel = PlaidInstitutionSentinel = {}));
